// import React from 'react';
import { useState } from 'react';
import {useNavigate, useParams} from 'react-router-dom';

// import BaixarCertificado from "./BaixarCertificado";
import "./certificados.css";
import {
	PopUpConteiner,
	PopUpMainConteiner
} from "./PopUpConteiner";

import ALink from '../../components/ALink';
import Header from '../../components/Header';
import MFooter from '../../components/MFooter'
import BtnDj from '../../components/Btn_dj'
import {Error} from '../../components/Erro';
import {LoadingV2} from '../../components/Loading';

// import {useFetch} from '../../hooks/useFetch'
import useFind from '../../hooks/useFind'
import planetasfind from "../../bd/planetas.js"

const img_generica = "/generico/g_extra..svg"

export const planetas = planetasfind();

function Main(){
	const params = useParams();
	const {certificado_id} = params;
	const {data: oficina_data, } = useFind('oficinas');

	const args = {
		oficina_data
	}
	// const [ocultarPopUp, setOcultarPopUp] = useState(false);
	return (
	  <>
	    {/* menu superior do dj*/}
	    <Header/>
	    {/*Conteudo*/}
	    <CertificadosBody params = {params} {...args}/>
			{
				!!certificado_id && (
					<CertificadosPopUp
						certificado_id={certificado_id}
						{...args}
					/>
				)
			}
	    {/*Rodape*/}
	    <MFooter/>
	  </>
	);
};

function CertificadosBody({oficina_data}){
	// const { user } = useContext(UserContext);
	//console.log("mb. user ",user)
	const certificados_modelo = {
		certificados:[
			{id:1,status:'loading'},
			{id:2,status:'loading'},
		],
		oficina_certificados:[
			{id:3,status:'loading'},
			{id:4,status:'loading'}
		],
	}
	// const certificados_data = certificados_modelo;
	const {data: certificados_data, } = useFind('user/certificados',certificados_modelo);
	// const {data: certificados_data, } = useFetch('user/certificados',certificados_modelo);
	const { certificados, oficina_certificados } = certificados_data;

	if (!certificados) return <div></div>
	const lista_certificados = certificados.map( (certificado,i) => {

			const planeta = planetas.find(p=>p.teste_final_id===certificado.teste_final_id)||{};
			return (
				<CertificadoBloco
					key={i}
					certificado={certificado}
					bloco = {{
						titulo: planeta.titulo||"",
						icone: getUrlIcone({planeta}),
						subtitulo: planeta.subtitulo||"",
						to: `/certificados/${certificado.id}`
					}}
					making = {certificado.url===""}
					loading={certificado.status==='loading'}
				/>
			)
		}
	)
	const lista_certificados_oficina = oficina_certificados.map(
		(certificado,i) => {

			const oficina = oficina_data.find(o=>o.id===certificado.oficina_id)||{};

			return (
			<CertificadoBloco
				key={i}
				certificado={certificado}
				bloco = {{
					titulo: oficina.nome,
					icone: getUrlIcone({oficina}),//oficina.url_icone,
					subtitulo: oficina.data,
					to: `/certificados/${certificado.id}`
				}}
				making = {certificado.url===''}
				loading={certificado.status==='loading'}
			/>
		)}
	)

	return (
		<section id="certificados" className="certificados">
			<div className="container" id="main">
				<h4 className="page-title ">Listando todos os meus certificados</h4>
			</div>
			<div className="container" id="plataforma"
				style={lista_certificados.length===0 ? {display:"none"}:{}}
			>
				<h5 className="page-title --mundos-spacing">da plataforma</h5>
				<div className="certificados-area">
					{lista_certificados}
				</div>
			</div>
			<div className="container" id="oficinas"
				style={lista_certificados_oficina.length===0 ? {display:"none"}:{}}
			>
				<h4 className="page-title --mundos-spacing">das oficinas</h4>
				<div className="certificados-area">
					{lista_certificados_oficina}
				</div>
				{lista_certificados_oficina.length===0 && <p className="certificados-title">
					Você não possui certificados de oficina cadastrado
				</p>}
			</div>
		</section>
	);
}

function CertificadoBloco(props){
	const {
		making, loading,
		bloco:{
			titulo,
			icone,
			subtitulo,
			to,
			// href
		},
	} = props

	if (!!loading){
		return (
			<div className={"certificados-box certificado-loading"}>
				<div className={"certificados-card"}>
					<div title='carregando marco' src="" className="certificados-icon"/>
					<span className="certificados-title" >{"  "}</span>
					<span className="certificados-subtitle">{"  "}</span>
				</div>
			</div>
		)
	}
	// em construção
	if (!!making){
		return (
			<div className={"certificados-box certificado-Lock"}>
				<div className={"certificados-card"}>

					<img alt='Marco em construção' src={process.env.PUBLIC_URL+"/img/mundos_logo/foguete_construindo2.jpg"} className="certificados-icon-rec"/>

					<span className="certificados-title" >{`${titulo} - Em construção`}</span>
					<span className="certificados-subtitle">Este certificado está em construção</span>
				</div>
			</div>)
	}

	// const url ={}
	// if (!! ) {
	// 	url.to = `/certificado/of/${certificado.id}`
	// } else {
	// 	url.href = certificado.url//`/certificado/${certificado.url}`
	// }
	// Ativado
	return (
		<ALink
			to={to}
			// href={href}
			className={"certificados-box click"}
		>
			<div className={"certificados-card"}>
				<img alt={`ícone${titulo}`} src={icone} className="certificados-icon"/>
				<span className="certificados-title" >{titulo}</span>
				<span className="certificados-subtitle">{subtitulo}</span>
			</div>
		</ALink>
	)
}

function CertificadosPopUp({certificado_id, oficina_data}){
	const {data:certificado_data, isLoading, error} =
		useFind(!!Number(certificado_id)
			? `certificados/${certificado_id}`
			: `OfCertificados/${certificado_id}`
		)

	if (error){
		return (
			<PopUpMain>
				{!!error.messages
					? <Error error={error.messages}/>
					: <Error error={`${error}`}/>}
			</PopUpMain>
		)
	}
	if (isLoading){
		return <PopUpMain isLoading={isLoading}/>
	}

	const planeta = planetas.find(p=>p.teste_final_id===certificado_data.teste_final_id)||{};
	const oficina = oficina_data.find(o=>o.id===certificado_data.oficina_id)||{};

	const data = new Date(certificado_data.updatedAt)
	const {
		titulo, texto, data_str, icone,
	} = !!Number(certificado_id)
	? {
		titulo : `Certificado - ${planeta.titulo}` ,
		texto : planeta.subtitulo ,
		data_str : data.toLocaleDateString()+" "+data.toTimeString() ,
		icone : getUrlIcone({planeta})//planeta.icone||img_generica
	}
	: {
		titulo : `Certificado - OF. Tech` ,
		texto : `${oficina.nome}` ,
		data_str : data.toLocaleDateString()+" "+data.toTimeString() ,
		icone : getUrlIcone({oficina})//oficina.url_icone||img_generica
	}

	// const url = `baixar/${certificado_data.id}`;//certificado_data.url


	// const btns = (!!baixar&&<BaixarSalvarCertificado certificado_id={certificado_id}/>) || []
	const btns = <BtnBaixarSalvarCertificado certificado_id={certificado_id}/>

		return (
			<PopUpMain>
				<div className="popup-bloco">
					<img alt={`ícone${titulo}`} src={icone} className="certificados-icon"/>
					<div>
						<h1 className="popup-titulo">{titulo}</h1>
						<h2 className="popup-h2">{texto}</h2>
					</div>
				</div>
				{btns}
				<div className="popup-texto">
					<p>{`Certificado gerado em: ${data_str}`}</p>
					{/* Baixar Certificado
					{certificado_data.url} */}
				</div>
			</PopUpMain>
		)
}

export default Main;



export function PopUpMain({isLoading, children}){
	const navigate  = useNavigate();
	function fechar() {
	  return navigate("/certificados");
	}
	const onClick = (e)=>{
		if( e.target.tagName==="MAIN" ) {
			fechar();
		}
			return true;
	}
	return (
		<PopUpMainConteiner onClick={onClick}>
			<PopUpConteiner className="certificados popup">
				<div id="fechar"
					onClick={()=>fechar()}
					className='popup-btn-x btn-voltar djbtn'
					title='fechar'
				>
					<i className="fi-rr-cross-circle"/>
				</div>
				{!!isLoading&&<LoadingV2/>}
				{children}

			</PopUpConteiner>
			{/* <BaixarCertificado _match={{params:{certificado_id:1}}}/> */}
		</PopUpMainConteiner>
	)
}

export function BtnBaixarSalvarCertificado({certificado_id,/*setBaixar*/}){
	const [baixar, setBaixar] = useState(false)
	// const btns = (!!baixar&&<BaixarSalvarCertificado certificado_id={certificado_id}/>) || []
	const btns = baixar
		? <BaixarSalvarCertificado certificado_id={certificado_id}/>
		: <BtnDj
			lista={ [ {
				texto : "Baixar Certificado",
				onClick: ()=>setBaixar(true),
			}]}
			/>

	return btns
}
export function BaixarSalvarCertificado({certificado_id,/*setBaixar*/}){
	const {
		data: certificado_data,
		isLoading, error
	} = useFind(`user/baixar_certificado/${certificado_id}`)

	if (isLoading){
		return (
			<BtnDj
				lista={[ { texto:"Baixando...", bloquado:true} ]}
			/>
		)
	}

	if (error){
		return ( <>
			{!!error.messages
				? <Error error={error.messages}/>
				: <Error error={error}/>}
			<BtnDj
				lista={[ { texto:"Falha ao baixar", bloquado:true } ]}
			/>
		</> )
	}

	return (
		<BtnDj
			lista={[ {
				texto:"Salvar Certificado",
				to: certificado_data.url,
				className: "baixar"
			} ]}
		/>
	)
}



export function getUrlIcone({oficina, planeta}){

	const path_icones = {
		base:process.env.PUBLIC_URL,
		planeta:process.env.PUBLIC_URL+"/img/mundos_logo/",
		oficina:process.env.PUBLIC_URL+"/img/oficina/",
		img_generica:process.env.PUBLIC_URL+"/img/mundos_logo/"+img_generica,
	}
	const icone =
		!!oficina ? oficina.url_icone :
		!!planeta ? planeta.icone :
		"";

	// console.log("icone:",icone,{oficina, planeta})
	if (!icone||icone===""){
		return path_icones.img_generica
	}
	else if (icone.includes("/img/")){
		return path_icones.base + (icone)
	}
	else if (icone.includes("://")){
		return icone
	}
	else if (oficina){
		return path_icones.oficina + (icone)
	}
	else if (planeta){
		return path_icones.planeta + (icone)
	}

	return path_icones.img_generica
}
